// 文档: https://cloud.tencent.com/document/product/436/11459
import COS from "cos-js-sdk-v5"
import md5 from "js-md5"
import { generateKeys } from "@/api/common"
import { Message } from "element-ui"
import store from "@/store"
let TempKeys = {
  muid: "",
  region: "",
  bucket: "",
  startTime: 0,
  expiredTime: 0,
  credentials: {
    sessionToken: "",
    tmpSecretId: "",
    tmpSecretKey: ""
  }
}

const getExt = path => {
  const re = /\.\w+$/
  const result = path.match(re)
  if (result === null) {
    return ""
  }
  return result[0]
}
/*
  option  文件  callback  回调   customkey 区分文件夹
*/
const uploadFile = async (file, callback, customkey = "files") => {
  await generateKeys().then(res => {
    const { data } = res
    if (data.bucket) {
      TempKeys = data
      Message.success("上传成功")
    } else {
      Message.success("上传失败")
    }
  })

  const cos = new COS({
    SecretId: TempKeys.credentials.tmpSecretId,
    SecretKey: TempKeys.credentials.tmpSecretKey,
    XCosSecurityToken: TempKeys.credentials.sessionToken
  })
  store.commit("SET_SHOW", true)
  // 随机化名字
  const filename =
    md5(TempKeys.muid + Date.now() + Math.random()) + getExt(file.name)
  try {
    cos.sliceUploadFile(
      {
        Bucket: TempKeys.bucket,
        Region: TempKeys.region,
        Key: customkey + "/" + filename,
        Body: file,
        ProgressInterval: 300,
        onProgress: progressData => {
          // console.log(JSON.stringify(progressData));
          store.commit("SET_PERCENTAGE", Math.floor(progressData.percent) * 100)
        }
      },

      function (err, data) {
        if (data.statusCode == 200) {
          Message.success("上传成功")
          callback(file, data)
        } else {
          Message.error("上传失败")
        }
      }
    )
  } catch (err) {
    throw err
  }
}

export { uploadFile, getExt }
